function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import * as React from 'react';
import styled from '../styled-components';
import { DialogContent, DialogOverlay } from '@reach/dialog';
import Times from '../icons/Times';
import { css } from 'styled-components';
var Overlay =
/*#__PURE__*/
styled(DialogOverlay).withConfig({
  displayName: "Dialog__Overlay",
  componentId: "byg4uw-0"
})(["&[data-reach-dialog-overlay]{background:rgba(0,0,0,0.5);", ";}"], function (props) {
  return props.data.zIndex && css(["z-index:", ";"], props.data.zIndex);
});
var Content =
/*#__PURE__*/
styled(DialogContent).withConfig({
  displayName: "Dialog__Content",
  componentId: "byg4uw-1"
})(["&[data-reach-dialog-content]{background:#ffffff;box-shadow:0 0 20px 0 rgba(0,0,0,0.12);width:558px;position:relative;border-radius:3px;}"]);
var CloseButton =
/*#__PURE__*/
styled(Times).withConfig({
  displayName: "Dialog__CloseButton",
  componentId: "byg4uw-2"
})(["width:16px;height:16px;position:absolute;top:-24px;right:-24px;cursor:pointer;"]);

var Dialog =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Dialog, _React$Component);

  function Dialog(props) {
    var _this;

    _classCallCheck(this, Dialog);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Dialog).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "open", function () {
      _this.setState({
        isOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "dismiss", function () {
      _this.setState({
        isOpen: false
      }, function () {
        if (_this.props.onDismiss) {
          _this.props.onDismiss();
        }
      });
    });

    _this.state = {
      isOpen: props.initialOpen || false
    };
    return _this;
  }

  _createClass(Dialog, [{
    key: "render",
    value: function render() {
      return React.createElement(React.Fragment, null, this.props.children && this.props.children(this.open, this.dismiss), React.createElement(Overlay, {
        isOpen: this.state.isOpen,
        onDismiss: this.dismiss,
        data: {
          zIndex: this.props.zIndex
        }
      }, React.createElement(Content, null, React.createElement(CloseButton, {
        onClick: this.dismiss,
        "aria-hidden": true
      }), this.props.content(this.dismiss))));
    }
  }]);

  return Dialog;
}(React.Component);

export { Dialog as default };